import { Button, styled } from "@mui/material";
import { colors } from "../../../../styles/theme";

export const Container = styled(Button)(({ theme }) => ({
  background: colors.text.v4,
  borderRadius: '10px',
  textAlign: 'center',
  textTransform: 'none',
  width: '100%',
  maxWidth: '220px',
}));